import { Button } from "react-bootstrap";
import CustomModal from "./../customModal/CustomModal";
import deleteusermodalimge from "../../assets/images/delete-user-modal-image.svg";
import React from "react";

interface DeleteConfModelProps {
  showModal: boolean;
  toggleModal: () => void;
  deleteAction: () => void;
  modelName: string;
  recordName?: string;
  isDeletePermitted?: boolean;
}

export const DeleteConfModel: React.FC<DeleteConfModelProps> = ({
  showModal,
  toggleModal,
  deleteAction,
  modelName,
  recordName,
  isDeletePermitted = true,
}) => {
  return (
    <>
      {showModal && (
        <CustomModal
          title=""
          content={
            <>
              <div className="modal--content--wrapper">
                <img src={deleteusermodalimge} alt="" />
                <h5>
                  Are you sure you want to <br />
                  delete this {modelName}{" "}
                  <span className="action-item-name" title={recordName || ""}>
                    '{recordName || ""}'
                  </span>
                  ?
                </h5>
              </div>
              <div className="modal--action--btn--wrapper">
                <Button
                  type="button"
                  variant="outline-primary"
                  onClick={toggleModal}
                >
                  Cancel
                </Button>
                <Button type="button" variant="primary" onClick={deleteAction} disabled={!isDeletePermitted}>
                  Delete
                </Button>
              </div>
            </>
          }
          onClose={toggleModal}
        />
      )}
    </>
  );
};
